import React from 'react'
import 'react-select/dist/react-select.css'
import {FaAngleDoubleLeft} from 'react-icons/fa'
import {FaAngleDoubleRight} from 'react-icons/fa'
import styles from './Paginator.scss'

import pagination from 'pagination'

const Paginator = ({ current, rowsPerPage, totalResult, pageLinks, onClick }) => {
  const reactTemplate = new pagination.TemplatePaginator({
    current: current || 1,
    rowsPerPage: rowsPerPage || 10,
    totalResult: totalResult || 0,
    pageLinks: pageLinks || 5,
    template: function(result) {
      const { pageCount, current, previous, next, range } = result

      if (pageCount < 2) {
        return []
      }

      const elements = []

      if (previous) {
        elements.push(
          <li key="previous" className={styles.previous} onClick={() => onClick(previous)}>
            <FaAngleDoubleLeft />
          </li>
        )
      } else {
        elements.push(
          <li key="previous" className={styles.hide}>
            <FaAngleDoubleLeft />
          </li>
        )
      }

      range.forEach(page => {
        if (page === current) {
          elements.push(
            <li key={page} className={styles.active}>
              {page}
            </li>
          )
        } else {
          elements.push(
            <li key={page} onClick={() => onClick(page)} className={styles.page}>
              {page}
            </li>
          )
        }
      })

      if (next) {
        elements.push(
          <li key="next" className={styles.next} onClick={() => onClick(next)}>
            <FaAngleDoubleRight />
          </li>
        )
      } else {
        elements.push(
          <li key="next" className={styles.hide}>
            <FaAngleDoubleRight />
          </li>
        )
      }

      return elements
    }
  })

  const elements = reactTemplate.render()

  return <ul className={styles.pagination}>{elements}</ul>
}

export default Paginator
